import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableSimpleCell from "ds/components/TableSimple/Cell";

import { StackPullRequestsTableRunCellProps } from "../types";

const StackPullRequestsTableRunEmptyCell = (cellProps: StackPullRequestsTableRunCellProps) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellEmpty />
    </TableSimpleCell>
  );
};

export default StackPullRequestsTableRunEmptyCell;
